/**
 * The admin's template for the brief (shared/taskPrompt.ts), held for
 * `taskPrompt()`, which is synchronous. Read on every socket (re)connect, so
 * another admin's edit arrives with the next one; saving here sets it at once.
 * With it, each repo's own (the Repos view's prompts), which a task in that
 * repo is filled from instead.
 */
import { ref } from "vue";
import { api } from "./api.js";
import { DEFAULT_TASK_PROMPT } from "@shared/taskPrompt.js";

export const taskPromptTemplate = ref(DEFAULT_TASK_PROMPT);
/** By repo, only the repos that have their own. */
export const repoTaskPromptTemplates = ref<Record<string, string>>({});

type Answer = { template: string; repos?: Record<string, string> };

export async function loadTaskPromptTemplate(): Promise<void> {
  try {
    const got = await api.get<Answer>("/api/task-prompt");
    taskPromptTemplate.value = got.template;
    repoTaskPromptTemplates.value = got.repos ?? {};
  } catch {
    // Keep what is held: the default, or the last one read.
  }
}

export async function saveTaskPromptTemplate(template: string): Promise<string> {
  const got = await api.put<Answer>("/api/task-prompt", { template });
  taskPromptTemplate.value = got.template;
  repoTaskPromptTemplates.value = got.repos ?? repoTaskPromptTemplates.value;
  return taskPromptTemplate.value;
}
